
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#474747"}},[_c('path',{attrs:{"d":"M7.892.003c-2.11.03-4.945.802-4.897 3.28.05 2.587 2.917 1.662 3.15 2.719.035-.045.088-.082.125-.125.197-.214.395-.388.593-.594.312-.352.636-.679.967-1.031 1.106-1.178 1.154-1.25 3.796-3.25-1.035-.62-2.258-.965-3.297-1-.134-.004-.296-.001-.437 0zm-1.903 1.53c.827 0 1.497.672 1.497 1.5a1.499 1.499 0 11-1.497-1.5zm7.269.662C11.84 4.43 10.89 5.751 9.888 6.783c-.639.657-1.163 1.311-1.622 1.78-.839.891-1.938 1.942-3.15 3.094.063 1.469.81 2.746 3.244 3.218 3.898.756 8.027-1.824 7.611-7.061-.178-2.248-1.405-4.281-2.713-5.619zm.342 3.807a1 1 0 010 2 1 1 0 010-2zm-.624 3a1 1 0 010 1.999 1 1 0 010-2zM7.986 11a1 1 0 010 2 1 1 0 010-2zm2.994 0a1 1 0 010 2 1 1 0 010-2zM0 13.5c1.552 0 1.394-1.788 2.147-2.286.874-.577 1.639.138 1.792.726.192.742-.117 1.631-1.13 1.885-1.074.268-2.662.276-2.809-.326z"}}),_c('path',{attrs:{"d":"M14.037.003c-1.8 1.299-4.206 3.302-6.115 5.333-.173.185-.34.363-.504.547-.104.108-.212.196-.315.308-.066.077-.126.163-.19.24-1.873 2.07-3.72 4.68-4.917 6.632 2.978-2.297 4.916-4.165 6.147-5.47.24-.246.53-.567.85-.923 1.204-1.335 2.926-3.438 5.044-6.667z"}})])])
          )
        }
      }
    